import { events } from '@Events';
import type { AppDispatch } from '../store';
import { refreshSubscriptionUsage } from './refreshSubscriptionUsage';

type ChargeableItem = 'research' | 'insight' | 'report_unlock';

// WE-115: wraps the SubscriptionUsage cache invalidation every paid action
// already needed, so the corresponding `charge_tokens` analytics event can't
// drift out of sync with it — call this instead of dispatching
// invalidateTags directly at a paid-action success site.
export function chargeTokens(dispatch: AppDispatch, item: ChargeableItem, analysisId?: number): void {
    refreshSubscriptionUsage(dispatch);
    events.emit('charge_tokens', { item, analysis_id: analysisId });
}
